import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import query from 'syf-component-library/const/mediaQueries';
import { fontSizes, fontWeights } from 'syf-component-library/defaultTheme';
import { Button, Card as CardCL, CardRow as CardRowCL } from 'syf-component-library/ui/atoms';
import { DatePicker } from 'syf-component-library/ui/patterns/DatePicker';
import { Inline, Inset } from 'syf-component-library/ui/spacing';
import H5 from 'syf-component-library/ui/typography/H5';
import { FAR_PEN } from '../../../const/iconProps';
import { colors, staticIcons } from '../../../defaultTheme';
import { t } from '../../../strings/i18n';
const EditAutopayButton = styled(Button) `
  margin-left: 0;
  padding-left: 0;

  @media ${query.greaterThanLarge} {
    margin-right: 0;
    padding-right: 0;
  }
`;
const EditAutopayButtonContainer = styled.div `
  @media ${query.greaterThanLarge} {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;
export const EditAutopay = ({ onClick }) => {
    return (_jsx(EditAutopayButtonContainer, { children: _jsxs(EditAutopayButton, Object.assign({ buttonType: "text", className: "ensightencustomevent", "data-cy": "edit-autopay-button", "data-object": "button", "data-reason": "edit autopay", "data-type": "payments", onClick: onClick }, { children: [_jsx(FontAwesomeIcon, { icon: FAR_PEN, size: "1x" }), _jsx(Inline, { size: "small" }), t('button.edit')] })) }));
};
export const OtherOption = styled.span `
  width: 100%;
  font-size: 14px;
  color: ${({ theme }) => theme.button.background};
  font-weight: ${fontWeights.bold};
  cursor: pointer;
  padding: 0 ${fontSizes.root}px;
`;
export const PaymentOption = styled(Inset) `
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 100%;
`;
export const PaymentMethodOption = styled.span `
  color: ${({ theme }) => theme.button.background};
  cursor: pointer;
  display: flex;
  font-weight: ${fontWeights.bold};
  justify-content: space-between;
  margin: 0 15px 0 0;
  width: 100%;
`;
export const SelectWrapper = styled(Inset) `
  padding: 0 0 24px;

  @media (min-width: ${query.medium}) and (max-height: ${query.large}) {
    #datepicker-wrapper {
      top: unset;
      bottom: calc(96px + 32px);
      margin: 0px;
      max-height: calc(100vh - 195px);
    }
  }
  @media (min-width: ${query.medium}) and (min-height: ${query.large}) {
    #datepicker-wrapper {
      max-height: 70vh;
    }
  }
`;
export const PaymentDatePicker = styled(DatePicker) `
  width: 100%;
  .react-datepicker {
    max-height: unset;
  }
  .react-datepicker-popper {
    z-index: 2;
  }

  input {
    opacity: 1;
  }
`;
export const ViewAccountMessageWrapper = styled.div `
  text-align: center;
`;
export const TextWrapper = styled(H5) `
  display: inline-block;
`;
export const ViewAccountButton = styled(Button) `
  display: inline-block;
  margin: unset;
  padding: unset;
`;
export const ViewAccountTextWrapper = styled(H5) `
  color: ${colors.black};
`;
export const IconCircle = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  border: 4px solid
    ${(props) => (props.$isError ? colors.error : colors.success)};
  width: 100px;
  height: 101px;
  border-radius: 50%;
`;
export const Card = styled(CardCL) `
  h5 {
    text-transform: none;
  }

  ${(props) => `
  ${props.mt ? `margin-top:${props.mt}px;` : ''}
  box-shadow: none;
  border-radius: 0;
  `}
`;
export const CardRowCLWrapper = styled(CardRowCL) `
  ${({ centerText }) => centerText && 'text-align: center;'}
  ${({ leftText }) => leftText && 'line-height: 12px;'}
  ${({ centerChildren }) => centerChildren && 'justify-content: center;'}
`;
const CardRowSpacingWrapper = styled(Inset) `
  border-bottom: ${({ hasBorderBottom }) => hasBorderBottom ? `1px solid ${colors.mediumGrey}` : ''};
`;
export const PaymentDetailsRow = ({ centerText, leftText, centerChildren, hasBorderBottom, children }) => {
    return (_jsx(CardRowSpacingWrapper, Object.assign({ hasBorderBottom: hasBorderBottom, hideOnBreakpointDown: "small", left: "base" }, { children: _jsx(CardRowCLWrapper, Object.assign({ centerChildren: centerChildren, centerText: centerText, leftText: leftText }, { children: children })) })));
};
export const FAI = styled(FontAwesomeIcon) `
  ${({ $isError, $header }) => {
    const color = $isError ? colors.error : colors.success;
    if ($header)
        return `
      font-size: 48px;
      color: ${color};
      `;
    return `
      color: ${staticIcons.statementsIconPrimary};
      padding-top: 16px;
      `;
}}
`;
export const FAIEditPayment = styled(FAI) `
  padding-top: 0px;
  margin-right: 8px;
`;
export const ProgressStepperWrapper = styled.div `
  padding-top: 24px;
`;
export const StepperWrapper = styled.div `
  margin: 24px 10% 0 10%;
`;
export const PrepaymentDetailsWrapper = styled.div `
  display: inline;
  padding: 0 24px 40px 24px;
`;
